export default "__VITE_PUBLIC_ASSET__13c8e1e7__"